import { defa }      from 'defa-object';
import ControlModel  from 'scripts/poppet/control-model';
import Notifications from 'scripts/defa/notifications/collection-notifications';
/**
 * defa.models.notificationHolder
 * The DEFA NotificationHolder model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	unitUrl: apiHost + '/units/',
	notifications: '/notifications',
	unread: '/unread'
};

const NotificationHolder = ControlModel.extend( {
	
	url: function ( ) {
		let url = api.unitUrl + this.get('id') + api.notifications
		if (this.get('getUnread')) {
			url += api.unread;
		}

		return url;
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
	{
		unreadNotifications:[],
		readNotifications: [],
		getUnread: null,
	}),

	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	addUnreadNotification( notification ) {
		this.get('unreadNotifications').add(notification, {at: 0});
	},

	addReadNotificaiton( notification ) {
		this.get('readNotifications').add(notification, {at: 0});
	},

	setReadNotifications( notifications ) {
		this.get('readNotifications').reset(notifications);
	},

	setUnreadNotifications( notifications ) {
		this.get('unreadNotifications').reset(notifications);
	},

	fetchReadNotifications: function(options) {
		this.set('getUnread' , false);
		
		this.fetch({
			success: options.success,
		});
	},

	parse: function( response ) {
		if( response ) {
			if( this.get('getUnread') ) {
				this.set({unreadNotifications: response});
			} else {
				//When fetching read notifications, unread shall be cleared
				this.set('unreadNotifications', []);
				this.set('readNotifications', response);
			}
		}
		this.receivedData( response );
		channel.request( 'notificationHolders' ).add( this, { merge: true } );
	},
	
	deleteAllNotifications: function (options) {
		let self = this;
		this.sync('delete', this, _.extend({
			url: this.url(),
			contentType: 'application/json',
		}))
			.done(function (response) {
				options.success(response);
				self.get('readNotifications').reset([]);
			})
			.fail(function (error) {
				options.error(error.responseJSON.message)
			})
		
	}
	
});

export default NotificationHolder;
